<template>
  <transition name="tgb-modal-fade">
    <div
      v-if="isVisible"
      class="tgbModalBackdrop"
    >
      <div
        tabindex="0"
        class="tgbModal"
        role="dialog"
        ref="modal"
        v-click-outside="close"
        @keydown.esc="close"
      >
        <div class="tgbModalHeader" v-if="$slots.header || headerText">
          <slot name="header" v-bind="headerText">
            <h2>
              {{ headerText }}
            </h2>
          </slot>

          <button
            type="button"
            class="tgbCloseBtn"
            data-entity="producer-closeModal"
            @click="close"
          >
            <span class="fas fa-plus" />
          </button>
        </div>

        <div class="tgbModalBody">
          <slot />
        </div>

        <div class="tgbModalFooter" v-if="$slots.footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TgbModal',
  props: {
    headerText: {
      type: String,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    open() {
      this.isVisible = true;
      // next tick forces this code to wait until the isVisible being true
      // redraws the dom. Otherwise it can't find the modal we're reffing.
      this.$nextTick(() => this.$refs.modal.focus());
      this.$emit('modal-open');
    },
    close() {
      // added to help with disabling validation before the el is removed
      // preventing console errors
      this.$emit('before-modal-close');
      this.$nextTick(() => {
        this.isVisible = false;
      });

      this.$emit('modal-close');
    },
  },
};
</script>

<style lang="scss">
.tgbModalBackdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(148, 162, 172, 0.4);
  backdrop-filter: blur(15px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.tgbModal {
  //background: #1B2224; // this is for the new theme
  background: #1e1e1e; // to match the old theme
  box-shadow: 0px 0px 14px 2px rgba(58, 88, 95, 0.24);
  border-radius: 10px;
  overflow-x: auto;
  padding: 40px 46px;
  position: absolute;
}

// todo - talk to lance about best approach here class vs all h tag
.tgbModalHeader :is(h1, h2, h3, h4, h5, h6) {
  font-family: 'Barlow Black',sans-serif; //todo: We need to import Barlow Black
  font-style: normal;
  font-weight: 400; //its 400 in the mock up but keeping the weight 400 makes it look thinner than how it "looks" in the mock up
  font-size: 28px;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
}

.tgbModalFooter {
  flex-direction: column;
  justify-content: flex-end;
}

.tgbModalControls {
  height: 42px;
  position: relative;
}

.tgbModalFooter {
  text-align: right;
}

.tgbCloseBtn {
  position: absolute;
  top: -7px;
  right: -10px;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6D7D85;
  transform: matrix(0.71, -0.71, 0.71, 0.71, 0, 0);
  background: transparent;
}

.tgbModalHeader {
  position: relative;
}

.tgbModalBody{
  position: relative;
}

.tgb-modal-fade-enter,
.tgb-modal-fade-leave-to {
  opacity: 0;
}

.tgb-modal-fade-enter-active,
.tgb-modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
